<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Your Account Details</h4>
            <p class="category">Please make sure the details below are accurate for your business.</p>
          </div>
          <div class="card-content">
            <form method="get" action="/" class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Email Address</label>
                  <div class="col-sm-10">
                    <input type="email" v-model="business.business_email" class="form-control">
                    <span class="help-block">Plese provide your contact email address for this business.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Business Name</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.business_name" class="form-control">
                    <span class="help-block">Plese provide your business name.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Website Domain/URL</label>
                  <div class="col-sm-10">
                    <input type="url" v-model="business.business_url" class="form-control">
                    <span class="help-block">Please provide the domain for your Shopify store, ie "mystore.com".</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Shopify Webhook</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.shopify_webhook_key" class="form-control">
                    <span class="help-block">Please provide your Shopify webhook key.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Street Address</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.address.line1" class="form-control">
                    <span class="help-block">Please provide your street address.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Apt/Suite</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.address.line2" class="form-control">
                    <span class="help-block">Please provide your apartment/suite number if you have one.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">City</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.address.city" class="form-control">
                    <span class="help-block">Please provide your city.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">State</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.address.state" class="form-control">
                    <span class="help-block">Please provide your state.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Zip Code</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.address.zipcode" class="form-control">
                    <span class="help-block">Please provide your zip code.</span>
                  </div>
                </div>
              </fieldset>

              <button type="submit" @click.prevent="persistBusiness()" class="btn btn-fill btn-info">Save</button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  import swal from 'sweetalert2'
  import firebase from 'firebase'

  export default {
    data () {
      return {
        loggedIn: false,
        axios_post_config: {
          headers: {
            'Content-Length': 0,
            'Content-Type': 'text/plain'
          },
          responseType: 'text'
        },
        business: {
          'business_name': '',
          'business_id': '',
          'email_content': {
            'invite_wait_period': '',
            'coupon_code': '',
            'discount_text': ''
          },
          'address': {
            'zipcode': '',
            'state': '',
            'city': '',
            'line2': '',
            'line1': ''
          },
          'other_url': '',
          'business_email': '',
          'business_url': '',
          'shopify_webhook_key': ''
        },
        loading: false
      }
    },
    methods: {
      async init () {
        let token = await this.$recaptcha('authenticate')
        let getIp = firebase.functions().httpsCallable('getIp')
        let result = await getIp({ token: token })
        console.log(result)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      fetchBusiness: function (businessUrl) {
        this.$http.get('https://api.vyoo.io/v1/business/?url=' + businessUrl)
        .then(function (response) {
          console.log(response.data)
          this.business = response.data
        })
      },
      persistBusiness2: function () {
        this.$http.post('https://api.vyoo.io/v1/business/', this.business).then(function (response) {
          console.log('Success!:', response.message)
          this.loading = false
        }, function (response) {
          console.log('Error!:', response.data)
          this.loading = false
        })
      },
      persistBusiness: function () {
        axios.post('https://api.vyoo.io/v1/business/', this.business, this.axios_post_config)
        .then(function (response) {
          console.log('saved successfully')
          swal.fire({
            title: `Saved`,
            text: 'Your profile has been saved',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Profile.vue